import * as React from "react";
import type { AppFlexMenuProps } from "./AppFlexMenu";
import type { AppFlexMenuProps as AppFlexMenuPropsV9 } from "./next";
import { AppFlexMenu } from "./AppFlexMenu";
import { AppFlexMenu as AppFlexMenuNext } from "./next/AppFlexMenu";

export const appFlexMenuRender = (props: AppFlexMenuProps): JSX.Element => (
  <AppFlexMenu {...props} />
);

export const appFlexMenuRenderV9 = (props: AppFlexMenuPropsV9): JSX.Element => (
  <AppFlexMenuNext {...props} />
);
